import { isIos } from '../utilities/helpers'

const iosDefocusFieldHack = () => {
  if (!isIos()) return
  const htmlElement = document.querySelector(`html`)
  htmlElement.style.cursor = `pointer` // necessary hack
  htmlElement.addEventListener(`click`, () => {}) // necessary hack
}

// tap anywhere on iOS to unfocus elements
export default {
  bind: iosDefocusFieldHack,
}
